import { render } from "./IconMainUsersActive.vue?vue&type=template&id=2a9bba6e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__